import TopButton from "../common/buttons/TopButton/TopButton";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import styles from "./PageLayout.module.scss";
import { Outlet } from "react-router-dom";


const PageLayout = () => {
  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.content}>
        <Outlet />
      </div>
      <Footer />
      <TopButton />
      {/* {hideTopBtn ? null : <TopButton />} */}
    </div>
  );
};

export default PageLayout;
